// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".explanation-tooltip-icon[data-v-5029f9cc]{cursor:pointer;outline:none;margin-left:5px;margin-bottom:-2px}.explanation-tooltip-icon path.fill[data-v-5029f9cc]{transition:fill .15s}.explanation-tooltip-icon:hover path.fill[data-v-5029f9cc]{fill:#aaa}p[data-v-5029f9cc]{white-space:normal}", ""]);
// Exports
module.exports = exports;
